import { v4 as uuidv4 } from 'uuid';
import { Langs } from '../../../../types/GlobalTypes';

const initId = uuidv4();

// GMT-791: defaults must cover every supported language, otherwise the form
// renders no inputs on the language tabs missing from these arrays
export const multilangStringDefault = Object.values(Langs).map(lang => ({ lang, value: '' }));

export const answersDefault = Object.values(Langs).map(lang => ({ lang, value: '', answerId: initId }));
